module.exports = __webpack_public_path__ + "img/2bea246.jpg";